export const unloadingPriorityFilters = [
    {
        label: "Receiving plant",
        data: [],
        selectedData: [],
        isFavourite: true,
        isMultiSelect: true
    },
    {
        label: "Sending plant",
        data: [],
        selectedData: [],
        isFavourite: true,
        isMultiSelect: true
    }, {
        label: "Waiting time",
        data: [],
        selectedData: [],
        isFavourite: true,
        isMultiSelect: true
    },
    {
        label: "BG",
        data: [],
        selectedData: [],
        isFavourite: true,
        isMultiSelect: true
    },

    {
        label: "Small C",
        data: [],
        selectedData: [],
        isFavourite: true,
        isMultiSelect: true
    },
    {
        label: "Format",
        data: [],
        selectedData: [],
        isFavourite: true,
        isMultiSelect: true
    }, {
        label: "Subformat",
        data: [],
        selectedData: [],
        isFavourite: true,
        isMultiSelect: true
    },
    {
        label: "Basepack",
        data: [],
        selectedData: [],
        isFavourite: true,
        isMultiSelect: true
    }, {
        label: "CBU",
        data: [],
        selectedData: [],
        isFavourite: true,
        isMultiSelect: true
    }
];

export const unloadingPriorityColumnsData = [
    {
        "label": "Format",
        "visibility": true,
        "DisplayOrder": 0,
        "sortable": true
    },
    {
        "label": "Basepack",
        "visibility": true,
        "DisplayOrder": 1,
        "sortable": true
    },
    {
        "label": "Basepack Desc",
        "visibility": true,
        "DisplayOrder": 2,
        "sortable": true
    },
    {
        "label": "Truck details",
        "visibility": true,
        "DisplayOrder": 3,
        "sortable": false
    },
    {
        "label": "Shipment details",
        "visibility": true,
        "DisplayOrder": 4,
        "sortable": false
    },
    {
        "label": "Order loss impact packs",
        "visibility": true,
        "DisplayOrder": 5,
        "sortable": false
    },
    {
        "label": "Order loss mitigated",
        "visibility": true,
        "DisplayOrder": 6,
        "sortable": false
    },
    {
        "label": "Weighted Score",
        "visibility": true,
        "DisplayOrder": 7,
        "sortable": true
    },
    {
        "label": "Big C",
        "visibility": true,
        "DisplayOrder": 8,
        "sortable": true
    }
];

export const INTR_expandCollapseColumns = ['Format', 'Basepack desc'];

export const formatIndianCurrency = (value) => {
    if (!value && value !== 0) return '0';

    const numValue = typeof value === 'string' ? Number.parseFloat(value) : value;

    if (Number.isNaN(numValue)) return '0';

    return numValue.toLocaleString('en-IN', {
        maximumFractionDigits: 2,
        minimumFractionDigits: 0
    });
};